import { Module, VuexModule, Mutation } from 'vuex-module-decorators';

interface SetScrollData {
    page: string;
    scrollPosition: number;
}

@Module({name: 'Scroll', namespaced: true})
export default class Scroll extends VuexModule {
    public staffAppPages = {
        dashboard: 0,
        tickets: 0,
        units: 0,
        inbox: 0,
    };

    public tenantAppPages = {
        dashboard: 0,
    };

    @Mutation
    public RESET_SCROLL_STORE_STATE() {
        this.staffAppPages = {
            dashboard: 0,
            tickets: 0,
            units: 0,
            inbox: 0,
        };

        this.tenantAppPages = {
            dashboard: 0,
        };
    }

    get getStaffAppPagePosition() {
        return (page: string) => this.staffAppPages[page];
    }

    get getTenantAppPagePosition() {
        return (page: string) => this.tenantAppPages[page];
    }

    @Mutation
    public SET_STAFF_APP_PAGE_SCROLL_POSITION(data: SetScrollData) {
        this.staffAppPages[data.page] = data.scrollPosition;
    }

    @Mutation
    public SET_TENANT_APP_PAGE_SCROLL_POSITION(data: SetScrollData) {
        this.tenantAppPages[data.page] = data.scrollPosition;
    }
}
